import { IonHeader, IonToolbar, IonTitle, IonButtons, useIonViewWillEnter } from '@ionic/react';
import React from 'react';
import './HeaderSosLocation.css';
import MenuButton from './MenuButton';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

interface ContainerProps {
    pageName: string;
}

const HeaderSosLocation: React.FC<ContainerProps> = ({ pageName }) => {

    // Este bloque se ejecutará cada vez que una página con este header se vaya a mostrar
    useIonViewWillEnter(() => {
        const setStatusBarColor = async () => {
            if (Capacitor.isNativePlatform()) {
                // Establece el color rojo para la barra de estado
                await StatusBar.setBackgroundColor({ color: '#e5100b' });
            }
        };
        setStatusBarColor();
    });

    return (
        <IonHeader mode="ios" className="header-red-location ion-no-border">
            <IonToolbar className="header-page header-sos-background-color">
                <IonButtons slot="start">
                    <MenuButton />
                </IonButtons>
                
                <IonTitle>
                    {pageName}
                </IonTitle>
            </IonToolbar>

            {/* Recordatorio: Este contenido debería estar en un <IonContent> en la página principal */}
            <div className='container'>
                <input type="text" className="caso-input" name="" id="" placeholder='Tipo de alerta' />
                <input type="text" className="caso-input" name="" id="" placeholder='Número de caso' />
                <input type="text" className="caso-input" name="" id="" placeholder='Estado del caso' />
            </div>
        </IonHeader>
    );
}

export default HeaderSosLocation;